import { DjangoTimeStamped } from '../django';
import { applyTimezone, parseDate } from '../helpers/date';

export class PrepaymentConditions {
  loanBalance: number;
  amount: number;
  dueDate: Date;
  balanceAfterPrepayment: number;
  newInstallments: any;
  savedAmount: any;

  constructor(data: any | PrepaymentConditions | DjangoPrepaymentConditions = {}) {
    if (data instanceof PrepaymentConditions) {
      bindPrepaymentConditionsData(this, data);
    } else {
      bindDjangoPrepaymentConditionsData(this, data);
    }
  }
}

export interface DjangoPrepaymentConditions extends DjangoTimeStamped {
  loan_balance: number;
  amount: number;
  due_date: string;
  balance_after_prepayment: number;
  saved_amount: number;
  new_installments: any;
}

function bindPrepaymentConditionsData(
  prepaymentConditions: PrepaymentConditions,
  data: PrepaymentConditions,
) {
  prepaymentConditions.loanBalance = data.loanBalance;
  prepaymentConditions.amount = data.amount;
  prepaymentConditions.dueDate = data.dueDate;
  prepaymentConditions.balanceAfterPrepayment = data.balanceAfterPrepayment;
  prepaymentConditions.savedAmount = data.savedAmount;
  prepaymentConditions.newInstallments = data.newInstallments;
}

function bindDjangoPrepaymentConditionsData(
  prepaymentConditions: PrepaymentConditions,
  data: DjangoPrepaymentConditions,
) {
  prepaymentConditions.loanBalance = data.loan_balance;
  prepaymentConditions.amount = data.amount;
  prepaymentConditions.dueDate = applyTimezone(parseDate(data.due_date), 0);
  prepaymentConditions.balanceAfterPrepayment = data.balance_after_prepayment;
  prepaymentConditions.savedAmount = data.saved_amount;
  prepaymentConditions.newInstallments = data.new_installments;
}
